import * as React from 'react'

import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'

import { Select as MuiSelect, SelectProps as MuiSelectProps } from '@mui/material'

interface SelectProps extends MuiSelectProps {
    options: {
        value: string
        label: string
    }[]
}

const Select = (props: SelectProps) => {
    return (
        <FormControl size="small" fullWidth>
            <InputLabel id={props.label as string}>{props.label}</InputLabel>
            <MuiSelect labelId={props.label as string} {...props} defaultValue="" label={props.label}>
                {props.options.map((item) => (
                    <MenuItem key={item.value} value={item.value}>
                        {item.label}
                    </MenuItem>
                ))}
            </MuiSelect>
        </FormControl>
    )
}

export default Select
